<template>
  <div class="page-content" v-if="user">
    <div class="content-wrapper">
      <!-- Page header -->
      <div class="page-header mb-2">
        <div class="page-header-content header-elements-md-inline">
          <div class="page-title d-flex">
            <h4 class="font-weight-semibold">Edit user: {{ user.username }}</h4>
          </div>
        </div>
      </div>
      <!-- /page header -->

      <!-- Content area -->
      <div class="content pt-0">
        <ul class="nav nav-tabs nav-tabs-bottom">
          <li class="nav-item">
            <a href="#account-setting" class="nav-link active" data-toggle="tab"
              >Account Settings</a
            >
          </li>
          <li class="nav-item">
            <a href="#edit-profile" class="nav-link" data-toggle="tab"
              >Edit Profile</a
            >
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane fade show active" id="account-setting">
            <AccountSettingTab :user="user"></AccountSettingTab>
          </div>
          <div class="tab-pane fade" id="edit-profile">
            <EditProfileTab :user="user"></EditProfileTab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceRoutes from '../../service-routes'
import AccountSettingTab from './AccountSettingTab.vue'
import EditProfileTab from './EditProfileTab.vue'

export default {
  components: { AccountSettingTab, EditProfileTab },
  data () {
    return {
      user: null
    }
  },
  mounted () {
    this.getUser()
  },
  methods: {
    getUser () {
      serviceRoutes.getUserByID(this.$route.params.id).then(data => {
        this.user = data.data
      })
    }
  }
}
</script>

<style></style>
